// hooks/useMobile.js
import { Grid } from "antd";
const { useBreakpoint } = Grid;
export const useMobile = () => {
  const screens = useBreakpoint();
  return (screens.xs && !screens.md) || window.innerWidth <= 768;
};
